import styled from "@emotion/styled";
import * as React from "react";

import { ChevronDown } from "@livechat/design-system-icons";
import {
  ActionMenu,
  ActionMenuItem,
  Button,
  IActionMenuOption,
  Icon,
  SpacingToken,
  Text,
} from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { TicketStatus, TicketStatusFormattedValues } from "interfaces/entities/ticket";
import { withVar } from "themes/helpers";

interface IProps {
  status: TicketStatus;
  isPrivate: boolean;
  onChange(status: TicketStatus): void;
  onMouseDown(e: React.MouseEvent<HTMLDivElement>): void;
}

interface IState {
  dropdownVisible: boolean;
}

const TicketStatusLabel = styled(Text)`
  @media (max-width: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.mobileBreakpoint
    }) {
    display: none;
  }
`;

export class TicketStatusDropdown extends React.PureComponent<IProps, IState> {
  state = {
    dropdownVisible: false,
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleButtonClick = () => {
    this.setState(prevState => ({
      dropdownVisible: !prevState.dropdownVisible,
    }));
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleClose = () => {
    this.setState({ dropdownVisible: false });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleSelect = (itemKey: TicketStatus) => {
    this.props.onChange(itemKey);
    this.handleClose();
  };

  private getOptions: IActionMenuOption[] = [
    TicketStatus.Open,
    TicketStatus.Pending,
    TicketStatus.OnHold,
    TicketStatus.Solved,
    TicketStatus.Closed,
  ].map(ticketStatus => ({
    key: ticketStatus,
    element: <ActionMenuItem>{TicketStatusFormattedValues[ticketStatus]}</ActionMenuItem>,
    onClick: () => this.handleSelect(ticketStatus),
  }));

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { status, onMouseDown } = this.props;
    const { dropdownVisible } = this.state;

    return (
      <Flex
        alignItems="center"
        marginRight={withVar(SpacingToken.Spacing2)}
        gap={withVar(SpacingToken.Spacing2)}
        onMouseDown={onMouseDown}
      >
        <TicketStatusLabel>Ticket status</TicketStatusLabel>
        <ActionMenu
          visible={dropdownVisible}
          placement="top-start"
          onClose={this.handleClose}
          options={this.getOptions}
          triggerRenderer={
            <Button
              size="compact"
              kind="secondary"
              onClick={this.handleButtonClick}
              iconPosition="right"
              icon={<Icon source={ChevronDown} />}
            >
              {TicketStatusFormattedValues[status]}
            </Button>
          }
        />
      </Flex>
    );
  }
}
